import { render, staticRenderFns } from "./strengthSet.vue?vue&type=template&id=21da159c&scoped=true&"
import script from "./strengthSet.vue?vue&type=script&lang=js&"
export * from "./strengthSet.vue?vue&type=script&lang=js&"
import style0 from "./strengthSet.vue?vue&type=style&index=0&id=21da159c&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21da159c",
  null
  
)

export default component.exports